<template>
	<div class="recharge_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.go(-1)"></div>
			<div class="big_tit">{{$t('invest.recharge')}}</div>
			<div class="top_right" @click="$router.push('/moneybag')">
				<van-icon name="bars" size="25"/>
			</div>
		</div>
		<div class="cards">
		    <div  class="top flex-b-s">
		        <div  class="top-left">
		            <div >{{$t('e.walletaccount')}}</div>
		            <div >{{1*balance}}<span >{{$t('e.usdc')}}</span></div>
		        </div>
		        <div  class="top-right"></div>
		    </div>
		    <div  class="middle">
		        <span @click="mtab=1" :class="mtab==1?'mActive':''">{{$t('e.TodaysEarnings')}}</span>
		        <span @click="mtab=2" :class="mtab==2?'mActive':''">{{$t('e.TotalEarnings')}}</span>
		    </div>
		    <div  class="bottom flex-b-c" v-if="tong">
		        <div v-if="mtab==1" class="bottom-left flex-e-s">
		            <div  class="left-item">
		                <div >{{$t('e.OrderRevenue')}}</div>
		                <div >{{tong.tfee}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('home.team')}}</div>
		                <div >{{tong.tteamfee}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('e.TotalEarnings')}}</div>
		                <div >{{tong.tfee + tong.tteamfee}}</div>
		            </div>
		        </div>
		        <div v-if="mtab==2" class="bottom-left flex-e-s">
		            <div  class="left-item">
		                <div >{{$t('e.OrderRevenue')}}</div>
		                <div >{{tong.allfee}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('home.team')}}</div>
		                <div >{{tong.allteamfee}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('e.TotalEarnings')}}</div>
		                <div >{{tong.allfee + tong.allteamfee}}</div>
		            </div>
		        </div>
		    </div>
		</div>
		
		<form class="form ">
			<div class="recharge_wrap shadow">
				<p>{{$t('invest.rechargeAmount')}}</p>
				<div class="flex_center">
					<input v-model.trim="data.money" type="number" min="1" step="1" class="inp"
						:placeholder="$t('invest.rechargeAmount')" @input="changeAmount">
					<!-- <span>{{actualAmount}}</span> -->
					<span>{{payment.mark}}</span>
					<span>（{{actualAmount}}）</span>
				</div>
				<div class="quick_wrap " >
					<!-- <p>
						{{$t('shopds.qselect')}}
					</p> -->
					<div class="flex_center">
						<span v-for="(v, k) in paynum" @click="changeAmount2(v)">{{v}}</span>
					</div>
				</div>
			</div>
			
			<div class="recharge_fs shadow">
				<div class="tit">
					{{$t('invest.paymentMethod')}}
				</div>
				<div v-for="(v, k) in config.payment" :key="k" class="item" @click="choose_type(k+1,v)">
					<div class="check" :class="k+1 == data.choose? 'checked' : ''" />
					<div class="re_icon"><img :src="v.logo" /></div>
					<div class="re_name">
						<!-- {{ v.name }} -->
					</div>
				</div>
			</div>
			<div class="basic_btn sbtn" @click="submit">
				{{$t('income.paynow')}}
			</div>
		</form>
		
		<div class="tip shadow" v-if="data.channel!=5">{{$t('invest.tip')}}</div>
		
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		CountDown,
		Checkbox,
		RadioGroup,
		Icon,
		Radio
	} from 'vant';
	import {
		jsBridge
	} from '../../utils/jsbridge-mini.js';
	import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";

	Vue.use(RadioGroup);
	Vue.use(Radio);
	Vue.use(CountDown).use(Checkbox).use(Icon);

	export default {
		name: "invest",
		data() {
			return {
				time: 0,
				eye: 1,
				tong:null,
				mtab: 1,
				balance: 0.00,
				data: {
					choose: '',
					channel: '',
					money: '',
					id: '',
					reason:''
				},
				paynum:[10000,20000,30000,50000,100000,200000,300000,500000,1000000,2000000,3000000,5000000],
				payment:[],
				config: {},
				actualAmount:'',
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
			var num = this.$router.history.current.params.code;
			if(num && num>0){
				this.data.money= num;
			}
		},
		methods: {
			start() {
				Fetch('/user/recharge', {
					...this.data
				}).then((r) => {
					var link = r.data.kefu_link;
					// window.location.href = link;
					// this.$router.push("/kefu");
					this.balance = r.data.money;
					this.config = r.data;
					this.config.min_recharge = parseInt(this.config.min_recharge);
					this.choose_type(1,r.data.payment[0]);
				});
				Fetch('/user/basicinfo').then((r) => {
					this.tong = r.data.tong;
				});
			},
			checkLimit() {
				const key = 'invest_button';
				const ttl = 60;
				let now = Date.parse(new Date()) / 1000;
				let val = localStorage.getItem(key);
				if (!val) {
					val = JSON.stringify({
						'ttl': now + ttl
					})
					localStorage.setItem(key, val)
					return true;
				} else {
					val = JSON.parse(val);
					if (val['ttl'] > now) {
						return false;
					} else {
						val = JSON.stringify({
							'ttl': now + ttl
						})
						localStorage.setItem(key, val)
						return true;
					}
				}
			},
			choose_type(k, payment) {
				this.data.choose = k;
				this.data.channel = payment.type;
				this.data.id = payment.id;
				this.payment = payment;
				this.changeAmount();
			},
			submit() {
				
				// return false;
				if (!this.data.money || (this.data.money / this.payment.rate) < this.config.min_recharge) {
					this.$toast(this.$t('invest.rechargeAmountLow') + this.utils_moneyMark() + this.config
						.min_recharge + this.$t('invest.rechargeAmountLow1'));
					return false;
				}
				if (!this.data.channel) {
					this.$toast(this.$t('invest.paymentMethodEmpty'));
					return false;
				}
				
				// if (!this.data.reason&&this.data.channel!=5) {
				// 	this.$toast(this.$t('invest.sendAddress'));
				// 	return false;
				// }
				// if (!this.checkLimit()) {
				// 	this.$toast(this.$t('invest.overtop'));
				// 	return false;
				// }

				if (this.data.channel == 4) {
					this.$router.replace({
						path: '/invest/bank',
						query: {
							payment: this.payment.id,
							acmoney: (this.data.money / this.payment.rate).toFixed(2),
							money: this.data.money,
							id: this.data.id
						}
					})
					this.$router.push("/kefu");
					return;
				} else if (this.data.channel == 1) {
					// this.$router.replace({
					// 	path: '/invest/usdt',
					// 	query: {
					// 		payment: this.payment.id,
					// 		acmoney: (this.data.money / this.payment.rate).toFixed(2),
					// 		money: this.data.money,
					// 		id: this.data.id,
					// 		reason:this.data.reason
					// 	}
					// })
					Fetch('/user/recharge_type', {
						money: this.data.money,
						payment: this.payment.id,
						type: "1",
						reason: "",
						acmoney: (this.data.money / this.payment.rate).toFixed(2),
						id:this.data.id
					}).then((r) => {
						  this.$router.push("/kefu");
						 //  if(r.data.payment.payurl!=''){
							// // window.open(r.data.payment.payurl,'_blank');
							// window.location.href = r.data.payment.payurl;
						 //  }
					});
					return;
				} else {
					//第三方支付
				  Fetch('/user/recharge_type', {
					money: this.data.money,
					payment: this.payment.id,
					type: "1",
					acmoney: (this.data.money / this.payment.rate).toFixed(2),
					id:this.data.id
				  }).then((r) => {
					  // this.$router.push("/kefu");
					  if(r.data.payment.payurl!=''){
						// window.open(r.data.payment.payurl,'_blank');
						window.location.href = r.data.payment.payurl;
					  }
				  });
				}
				// Fetch('/user/invest/apply', {
				//     ...this.data
				// }).then(() => {
				//     this.$router.replace('/login');
				// });
			},
			changeAmount() {
				var num = 0;
				if(this.payment.type){
					if (this.payment.type == 1) {
						if (this.payment.rate > 10000) {
							num = 8;
						} else if (this.payment.rate > 1000) {
							num = 6;
						} else if (this.payment.rate > 10) {
							num = 4;
						}
						this.actualAmount = " ≈ COP " + (this.data.money / this.payment.rate).toFixed(num) + '';
					} else {
						this.actualAmount = " ≈ " + this.payment.mark + (this.data.money / this.payment.rate).toFixed(num);
					}
				}
			},
			changeAmount2(vnum) {
				this.data.money = vnum ;
				var num = 0;
				if(this.payment.type){
					if (this.payment.type == 1) {
						if (this.payment.rate > 10000) {
							num = 8;
						} else if (this.payment.rate > 1000) {
							num = 6;
						} else if (this.payment.rate > 10) {
							num = 4;
						}
						this.actualAmount = " ≈ COP " + (this.data.money * this.payment.rate).toFixed(num) + ' ';
					} else {
						this.actualAmount = " ≈ COP "  + (this.data.money / this.payment.rate).toFixed(num);
					}
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
	}

	.balance {
		background: #ffffff;
		border-radius: 6px;
		padding: 20px 0px;
		margin: 10px;
		text-align: center;
		p:nth-child(1) {
			font-size: 26px;
			font-weight: bold;
			margin-bottom: 15px;
		}

		p:nth-child(2) {
			color: #999;
			font-weight: bold;
		}
	}

	.recharge_fs {
		margin-top: 10px;
		background: rgba(255, 255, 255, 1);
		border-radius: 6px;
		padding: 0 16px;
	}

	.recharge_box {
		width: 100%;
		height: 48px;
		background: rgba(255, 255, 255, 1);
		border-radius: 6px;
		margin-top: 12px;
		padding: 16px 11px;

		input {
			height: 18px;
			width: 100%;
			line-height: 18px;
			font-size: 14px;
		}
	}

	.form {
		margin: 10px;

		.recharge_wrap {
			width: 100%;
			background: #ffffff;
			border-radius: 6px;
			padding: 16px;
			margin-top: 10px;
			.flex_center {
			  justify-content: left;
			}
			.reason{
				width: 100%;
			}
			input {
				height: 30px;
				width: 40%;
				padding: 5px;
				line-height: 18px;
				margin-right: 5px;
				font-size: 12px;
				border: solid 1px #fce582;
			}
			div {
				span:nth-child(2){
					// font-size: 18px;
					// margin-right: 10px;
					// font-weight: bold;
				}
				// span:nth-child(3){
				// 	font-size: 14px;
				// 	width: 40%;
				// 	color: #999;
				// 	text-align: right;
				// }
			}

			p:nth-child(1) {
				font-size: 16px;
				font-weight: bold;
				color: #999;
				margin-bottom: 20px;
			}

			p:nth-child(3) {
				color: #999;
				margin-top: 20px;
			}

		}

		.tit {
			height: 54px;
			border-bottom: 1px solid #ECECEC;
			font-size: 16px;
			color: #999;
			font-weight: bold;
			line-height: 54px;
		}

		.item {
			height: 57px;
			border-bottom: 1px solid #ECECEC;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			&:last-child {
				border-bottom: none;
			}

			.check {
				width: 16px;
				height: 16px;
				margin-left: 4px;
				background: url(../images/user/c2.png) no-repeat center center;
				background-size: 100% 100%;

				&.checked {
					background: url(../images/user/c1.png) no-repeat center center;
					background-size: 100% 100%;
				}
			}

			.re_icon {
				// width: 20px;
				height: 30px;
				margin-left: 11px;

				img {
					// width: 20px;
					height: 30px;
				}
			}

			.re_name {
				font-size: 16px;
				line-height: 22px;
				color: rgba(0, 0, 0, .8);
				margin-left: 4px;
			}

			.wx {
				background: url(../images/user/recharge3.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.alipay {
				background: url(../images/user/recharge2.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.usdt {
				background: url(../images/user/recharge1.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.alipay_app {
				background: url(../images/user/recharge2.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.bank {
				background: url(../images/user/recharge4.png) no-repeat center center;
				background-size: 100% 100%;
			}
		}
	}
	.tip{
		display: block;
		margin: 8px;
		padding: 16px;
		border-radius: 16px;
		background-color: #FFFFFF;
		line-height: 24px;
		color: #999;
		font-size: 12px;
	}
	.sbtn {
		margin: 20px auto;
	}
	.quick_wrap{
		margin-top: 3%;
		padding-top: 3%;
		background-color: #fff;
		p{
			font-size: 14px;
			font-weight: bold;
			line-height: 30px;
		}
		.flex_center{
			width: 100%;
			display: -webkit-box;
			display: -webkit-flex;
			display: flex;
			-webkit-flex-wrap: wrap;
			flex-wrap: wrap;
			span{
				width: 21%;
				display: block;
				height: 35px;
				line-height: 35px;
				font-size: 12px;
				background-color: #fce582;
				border: 1px solid #fce582;
				text-align: center;
				color: #191715;
				margin-right: 10px;
				margin-bottom: 10px;
				border-radius: 5px;
				font-weight: bold;
				max-width: 85px;
			}
		}
	}
	.cards{
		padding: 16px;
		margin: 16px;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		color: #FFF;
		line-height: 20px;
		background: linear-gradient(180deg, #000 0%, #000 100%);
		.flex-e-s {
		    display: flex;
		    justify-content: space-between;
		    align-items: flex-end;
		}
		.top {
		    margin-bottom: 8px;
		}
		
		.top div {
		    font-weight: 700;
			font-size: 15px;
			line-height: 25px;
		}
		
		.top .top-left>div:last-child {
		    word-break: break-all;
		    font-style: italic;
		    font-size:26px;
			    
		}
		.flex-b-c {
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		}
		.top .top-left>div:last-child span {
		    font-style: normal;
		    font-size: 12px;
			font-weight: 400;
		}
		
		.top .top-right {
		    text-align: center
		}
		
		.top .top-right .group {
		    background-color: var(--84e63418);
		    color: var(--78b8770c);
		    padding: 2px 5px;
		    font-size: 12px;
		    flex-shrink: 0
		}
		
		.top .top-right .group img {
		    margin-right:4px
		}
		
		.top .top-right>div:first-child {
		    margin-bottom: 8px
		}
		
		.top .top-right div {
		    background-color: #fff;
		    padding: 2px 8px;
		    color: #000;
		    border-radius: 8px
		}
		
		.middle {
		    display: flex;
		    align-items: center
		}
		
		.middle span:first-child {
		    margin-right: 10px;
		}
		
		.middle span {
		    display: inline-block;
		    font-size: 12px;
		    padding: 2px 5px;
		    text-align: center;
		    color: #FFF;
		    border: 1px solid #FFF;
		    border-radius: 4px;
			line-height: 20px;
		}
		
		.mActive {
		    background-color: #F1BB0E;
		    color: #000!important;
		    border: none!important
		}
		
		.bottom {
		    margin-top: 8px
		}
		
		.bottom .bottom-left .left-item:not(:last-child) {
		    border-right: 1px solid #F1BB0E
		}
		
		.bottom .bottom-left .left-item:last-child {
		    margin-right: 0
		}
		
		.bottom .bottom-left .left-item {
		    display: flex;
		    flex-direction: column;
		    align-items: start;
		    justify-content: center;
		    margin-right: 10px;
		    padding-right: 10px;
		    font-size: 16px
		}
		
		.bottom .bottom-left .left-item div {
		    color: var(--40ca1237)
		}
		
		.bottom .bottom-left .left-item div:first-child {
		    opacity: .8;
		    font-size: 12px
		}
		
		.bottom .bottom-left .left-item div:last-child {
		    font-weight: 600;
		    word-break: break-all
		}
	}
</style>
